import {useEffect, useState} from 'react';

import {GemModuleItems} from 'app/interface';
import {useLazyLoadPage} from 'app/modules/lazyLoadPage/useLazyLoadPage';
import {useGemSettings} from 'app/utils/config/gemSettingsProvider';
import {findAndInitComponents} from 'app/utils/initialize/findAndInitComponents';
import {initDeprecated} from 'app/utils/initialize/initDeprecated';
import {ComponentMountDataTransporter} from 'app/utils/initialize/interface';

export function useComponentMountDataItems(context: HTMLElement, components: GemModuleItems) {
    const lazyLoadPage = useLazyLoadPage();
    const [componentMountDataTransporterItems, setComponentMountDataTransporterItems] = useState<ComponentMountDataTransporter[]>([]);
    const gemSettings = useGemSettings();

    useEffect(() => {
        findAndInitComponents({
            gemSettings,
            context,
            lazyLoadPage,
            components,
            selector: '.gem-module-not-initialized:not([data-rendered-remotely])',
            callback(componentMountDataTransporter) {
                setComponentMountDataTransporterItems((prevItems) => {
                    return [...prevItems, componentMountDataTransporter];
                });
            },
        });

        initDeprecated(context, gemSettings);
    }, [components, context, gemSettings, lazyLoadPage]);

    return componentMountDataTransporterItems;
}
